import { useHistory, useParams } from "react-router-dom";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";

const MobileMenu = ({ onClose }) => {
  const history = useHistory();
  const { orgId } = useParams();

  const navigate = (path) => {
    history.push(path);
    onClose();
  };

  return (
    <div className="mobile-menu-overlay">
      <div className="mobile-menu-header">
        <button
          className="mobile-menu-close"
          onClick={onClose}
        >
          <CloseOutlinedIcon />
        </button>
      </div>

      <nav className="mobile-menu-nav">
        <button
          className="mobile-menu-item"
          onClick={() => navigate(`/${orgId}/`)}
        >
          Home
        </button>

        <button
          className="mobile-menu-item"
          onClick={() => navigate(`/${orgId}/mycalendar`)}
        >
          Mijn agenda
        </button>

        <button
          className="mobile-menu-item"
          onClick={() => navigate(`/${orgId}/fullcalendar`)}
        >
          Volledige agenda
        </button>

        <button
          className="mobile-menu-item"
          onClick={() => navigate(`/${orgId}/myhouseholds`)}
        >
          Mijn huishoudens
        </button>
      </nav>
    </div>
  );
};

export default MobileMenu;
